var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 25.3461 24.3945",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logout"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5785 0C14.6066 0 17.0762 2.42725 17.0762 5.41558V11.2581H9.63016C9.09653 11.2581 8.67459 11.6728 8.67459 12.1973C8.67459 12.7095 9.09653 13.1364 9.63016 13.1364H17.0762V18.9667C17.0762 21.9551 14.6066 24.3945 11.5537 24.3945H5.51004C2.46959 24.3945 0 21.9673 0 18.9789V5.42778C0 2.42725 2.482 0 5.52245 0H11.5785ZM20.1745 7.98945C20.5404 7.61133 21.1381 7.61133 21.504 7.97725L25.0656 11.5266C25.2486 11.7096 25.3461 11.9414 25.3461 12.1975C25.3461 12.4414 25.2486 12.6854 25.0656 12.8561L21.504 16.4056C21.321 16.5885 21.0771 16.6861 20.8454 16.6861C20.6014 16.6861 20.3575 16.5885 20.1745 16.4056C19.8086 16.0396 19.8086 15.442 20.1745 15.076L22.1261 13.1367H17.0764V11.2583H22.1261L20.1745 9.31895C19.8086 8.95303 19.8086 8.35536 20.1745 7.98945Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.a5ee38a089aa61ed4424274be47d14df.svg";
export { ForwardRef as ReactComponent };